import { ApiResult } from "~/models/ApiResult";
import { type AxiosResponse } from "axios";
import { BaseService } from "./BaseService";
import {
  NotificationsResponse,
  NotificationRequest
} from "~/models/NotificationModels";
export class NotificationService extends BaseService {
  constructor() {
    super("Notification");
  }

  GetNotificationsList(query: NotificationRequest): Promise<AxiosResponse<ApiResult<Array<NotificationsResponse>>>> {
    return this.client.Get<ApiResult<any>>(`${this.baseUrl}/List`, query)
  }
  ReadNotification(body: { id: number }): Promise<AxiosResponse<ApiResult<any>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/Read`, body)
  }
  ReadAllNotification(): Promise<AxiosResponse<ApiResult<any>>> {
    return this.client.Post<ApiResult<any>>(`${this.baseUrl}/ReadAll`, {})
  }

}
